import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../lib/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    (async () => {
      const hash = window.location.hash || "";
      const m = hash.match(/session_id=([^&]+)/);
      if (!m) {
        navigate("/login");
        return;
      }
      const session_id = m[1];
      try {
        const { data } = await api.post("/auth/emergent-session", { session_id });
        setUser(data.user);
        // clear hash
        window.history.replaceState(null, "", window.location.pathname);
        toast.success("Accesso effettuato con Google");
        navigate("/dashboard", { replace: true, state: { user: data.user } });
      } catch (e) {
        toast.error("Errore autenticazione Google");
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FBF9F5]">
      <div className="text-[#231F1D] font-heading text-lg">Accesso in corso...</div>
    </div>
  );
}
